import styled, { css } from 'styled-components';

const commonPadding = css`
  padding: 16px 0;
`;

export const CaptionWrapper = styled.div`
  ${commonPadding}
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const DateWrapper = styled.div`
  ${commonPadding}
`;

export const BtnInterviewWrapper = styled.div`
  ${commonPadding}
  text-align: left;
`;

export const BtnContentsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > svg {
    margin-right: 4px;
    width: 16px;
    height: 16px;
  }
`;
